module.exports = __webpack_public_path__ + "static/media/Contentsquare.f7d86f0d.svg";